import { render, staticRenderFns } from "./FeedbackView.vue?vue&type=template&id=465ca863&scoped=true"
import script from "./FeedbackView.vue?vue&type=script&lang=js"
export * from "./FeedbackView.vue?vue&type=script&lang=js"
import style0 from "./FeedbackView.vue?vue&type=style&index=0&id=465ca863&prod&scoped=true&lang=less"
import style1 from "./FeedbackView.vue?vue&type=style&index=1&id=465ca863&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ca863",
  null
  
)

export default component.exports